import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../../../mp-core/themes/palette"

type StyleProps = {
  width: number
  arcLength: number
  arcProgress: number
  progressColor: string
  isRightSide?: boolean
}

export const useStyles = makeStyles<StyleProps>()(
  (
    { palette },
    { width, arcLength, arcProgress, progressColor, isRightSide = false }
  ) => ({
    scoreArcScale: {
      stroke: blueGrey[100],
      strokeWidth: width,
      strokeLinecap: "round",
      fill: "none"
    },
    scoreArcEmpty: {
      stroke: palette.common.white,
      strokeWidth: width - 2,
      strokeLinecap: "round",
      fill: "none"
    },
    scoreArcPercentage: {
      stroke: progressColor,
      strokeWidth: width,
      strokeLinecap: "round",
      fill: "none",
      strokeDasharray: arcLength,
      strokeDashoffset: isRightSide ? -arcProgress : arcProgress
    }
  })
)
